/**
 * @desc 分页
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.defaultShopInfo.page.Params, options?: any) {
  return updateResponse(
    http(URL + `/defaultShopInfo/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
